/**
 * PointsBadge Component
 * Compact badge displaying seller's total points with icon
 * Used in listing cards and seller info displays
 */

import React from 'react';
import { Award } from 'lucide-react';

const PointsBadge = ({ points, size = 'sm', showIcon = true, className = '' }) => {
  // Determine size classes
  const sizeClasses = {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
  };

  const iconSizes = {
    xs: 'h-3 w-3',
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
    lg: 'h-6 w-6',
  };

  return (
    <div
      className={`inline-flex items-center gap-1 ${sizeClasses[size]} font-medium text-slate-700 ${className}`}
      title={`${points} total points`}
    >
      {showIcon && <Award className={`${iconSizes[size]} text-amber-500`} />}
      <span className="font-semibold text-slate-900">{points}</span>
      <span className="text-slate-500">pts</span>
    </div>
  );
};

export default PointsBadge;
